<template>
  <!-- 直播围观人数 -->
  <div class="live-top" v-if="viewerList.length">
    <div class="live-people">
      <template v-for="(item,index) in viewerList.slice(0,3)">
          <img
            class="live-logo"
            :src="item.avatarUrl"
            v-if="item.avatarUrl"
            :key="index"
            v-load="'oAvatarSmall'"
          />
          <img class="live-logo" src="@/assets/img/empty.png" v-else  :key="index"/>
      </template>
      <div
        class="live-count"
        :class="count > 0 ?'':'live-count-none'"
      >{{this.getCount(count)}}</div>
    </div> 
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import config from "../../../static/config.json";

export default {
  name: "navigation",
  props:['companyInfo'],
  data() {
    return {
      viewerList:[],
      count:0,
    };
  },
  watch:{
    companyInfo(new2,old){
        let list = new2.followList;
        this.init(list);
    },
  },
  created() {
    let list = this.companyInfo.followList;
    this.init(list);
  },
  methods: {
    // 人数超过w换算
    getCount(param) {
      let count = 0;
      if (param > 10000) {
        count = (param / 10000).toFixed(1);
        if (String(count)[count.length - 1] == 0) {
          count = (count / 1).toFixed(0);
        }
        return count + "w";
      }
      return param;
    },
    init(list){
      let viewerList = list;
      let arr = [];
      viewerList.map(c =>{
        if(c&&c.indexOf('{') !== -1){
          c = JSON.parse(c);
          arr.push(c);
        }
      })
      this.viewerList = arr;
      this.count = this.companyInfo.exInfo.followCount;
    },
  }
};
</script>

<style scoped lang="scss">
.live-top { 
  min-height: 0.6rem;
  flex:1;
  display: flex;
  align-items: center;
  flex-direction: row-reverse;
}
.live-info {
  width: 80%;
  height: 0.6rem;
  line-height: 0.6rem;
  background-image: url(../../assets/img/live/arrow-l.png),
    url(../../assets/img/live/arrow-r.png),
    linear-gradient(0deg, #ff4b1f 0%, #ff9068 100%), linear-gradient(#000, #000);
  background-repeat: no-repeat;
  background-size: 0.47rem 0.29rem, 0.49rem 0.33rem, auto, auto;
  background-position: 2% 30%, 98% 70%, 0% 0%, 0% 0%;
  border-radius: 0.3rem 0.3rem 0.3rem 0.3rem;
  &-content {
    width: 80%;
    padding: 0 0.5rem;
    height: 0.6rem;
    line-height: 0.6rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: flex;
    align-items: center;
    img {
      width: 0.3rem;
      height: 0.3rem;
      border-radius: 50%;
      display: inline-block;
      margin-right: 0.15rem;
      background-color: #fff;
    }
    p {
      color: #fff;
      width: 3.5rem;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      padding-top: .05rem;
    }
  }
}
.live-people {
  min-width: 2rem;
  width: 20%;
  height: 0.46rem;
  display: flex;
  justify-content: flex-end;
}

.live-logo {
  width: 0.46rem;
  height: 0.46rem;
  border-radius: 50%;
  display: block;
  border: 1px solid #fff;
}

.live-logo:nth-child(1) {
  z-index: 103;
  position: relative;
}

.live-logo:nth-child(2) {
  z-index: 102;
  position: relative;
  margin-left: -0.2rem;
}

.live-logo:nth-child(3) {
  z-index: 99;
  position: relative;
  margin-left: -0.2rem;
}

.live-count {
  min-width: 0.96rem;
  height: 0.46rem;
  line-height: 0.46rem;
  color: #fff;
  font-size: 0.2rem;
  background-color: rgba(0, 0, 0, 0.4);
  border-radius: 0.46rem;
  display: inline-block;
  padding-left: 0.36rem;
  margin-left: -0.44rem;
  text-align: center;
}
.live-count-none {
  margin: 0;
  padding: 0;
}
.m-action-sheet {
  height: 6.5rem;
}
/* 组件 */
.m-list {
  padding: 0;
}

.m-list-title {
  line-height: 0.9rem;
  text-align: center;
  font-size: 0.26rem;
  font-weight: 600;
  border-bottom: 1px solid #f2f2f2;
}

.m-list-content {
  padding-left: 0.3rem;
  min-height: 0.3rem;
  font-size: 0.26rem;
}
.m-list-wrap {
  border-radius: 0.17rem 0.17rem 0 0;
}
.m-list-item {
  height: 1rem;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #f2f2f2;
}

.mli-avatar {
  width: 0.56rem;
  height: 0.56rem;
  background-color: #fff;
  border-radius: 50%;
}

.mli-info {
  padding-left: 0.18rem;
  font-size: 0.26rem;
  color: #333;
  margin-right: 0.1rem;
  width: 40%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.mli-brand {
  font-size: 0.2rem;
  color: #666;
  width: 40%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.my-half-title {
  font-size: 0.4rem;
}

.empty {
  line-height: 4rem;
  text-align: center;
  color: #ccc;
  font-size: 0.4rem;
}

.load {
  text-align: center;
  padding: 10px;
}

.page-section-spacing {
  margin-top: 60px;
}
.scroll-view_H {
  white-space: nowrap;
}
.scroll-view-item {
  height: 0.6rem;
}
.scroll-view-item_H {
  display: inline-block;
  width: 100%;
  height: 0.6rem;
}
.demo-text-1 {
  background: red;
}
.demo-text-2 {
  background: green;
}
.demo-text-3 {
  background: blue;
}
</style>
